import ProjectCard from "./projectCard";
import PageTitle from "../common/pageTitle";

const projects = [
  {
    projectName: "Trip Tango",
    techStack: ["Typescript", "React", "Gemini API", "GCP"],
    imgUrl: "./assets/images/projects/trip-tango.png",
    link: "https://trip-tango.vercel.app",
  },
  {
    projectName: "Cryptopia",
    techStack: ["Flutter", "Coin-Gecko-API"],
    imgUrl: "./assets/images/projects/cryptopia.png",
    link: "https://github.com/sharansukesh1003/CryptoPia",
  },
  {
    projectName: "GPT-Mobile",
    techStack: ["Flutter", "TTS", "STT"],
    imgUrl: "./assets/images/projects/gpt-mobile.png",
    link: "https://github.com/sharansukesh1003/GPT-Mobile",
  },
  {
    projectName: "Eats Tracker",
    techStack: ["Javascript", "React", "HTML", "CSS"],
    imgUrl: "./assets/images/projects/eats-tracker.jpeg",
    link: "https://chromewebstore.google.com/detail/eats-tracker/ngodbkadlefiadjbkbdlnpklgdkndaep",
  },
  {
    projectName: "Amazon Price Tracker",
    techStack: ["NodeJS", "Express JS", "Mongo-DB"],
    imgUrl: "./assets/images/projects/amazon-price-tracker.png",
    link: "https://github.com/sharansukesh1003/price-tracker-api",
  },
  {
    projectName: "Esports Now",
    techStack: ["Flutter", "Firebase"],
    imgUrl: "./assets/images/projects/esports-now.png",
    link: "https://github.com/sharansukesh1003/Esports-Now-App",
  },
  {
    projectName: "Foodie",
    techStack: ["Flutter", "Java"],
    imgUrl: "./assets/images/projects/food-delivery.png",
    link: "https://github.com/sharansukesh1003/Food-Delivery-App-UI",
  },
  {
    projectName: "Messenger",
    techStack: ["Flutter", "Firebase", "Google Auth"],
    imgUrl: "./assets/images/projects/messenger.png",
    link: "https://github.com/sharansukesh1003/Messenger",
  },
  {
    projectName: "Todo",
    techStack: ["Flutter", "Hive DB"],
    imgUrl: "./assets/images/projects/todo.png",
    link: "https://github.com/sharansukesh1003/todo-advanced",
  },
  {
    projectName: "WASD",
    techStack: ["Flutter", "NodeJS", "Express JS", "Mongo-DB"],
    imgUrl: "./assets/images/projects/wasd.png",
    link: "https://github.com/sharansukesh1003/WASD-Social-Network",
  },
  {
    projectName: "Climate Bot Tim",
    techStack: ["NodeJS", "Express JS"],
    imgUrl: "./assets/images/projects/tim-bot.png",
    link: "https://github.com/sharansukesh1003/Climate-Bot-Tim",
  },
];

function Projects() {
  return (
    <div className="my-5 px-5">
      <PageTitle title={"Projects"} />
      <div className="mt-10 md:grid md:grid-cols-3 gap-5">
        {projects.map((project, index) => (
          <ProjectCard
            key={index}
            link={project.link}
            delay={index * 0.1}
            imgUrl={project.imgUrl}
            techStack={project.techStack}
            projectName={project.projectName}
          />
        ))}
      </div>
    </div>
  );
}

export default Projects;
